import { faFileDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

export interface IExportToExcelButtonProps {
  onClick: () => Promise<void>;
}

export const ExportToExcelButton = (
  props: IExportToExcelButtonProps,
): JSX.Element => {
  const [downloading, setDownloading] = useState(false);

  const handleClick = () => {
    setDownloading(true);
    props.onClick().finally(() => {
      setDownloading(false);
    });
  };

  return (
    <Button
      variant="link"
      disabled={downloading}
      onClick={handleClick}
      className="text-primary font-weight-bold pr-0"
    >
      {!downloading && (
        <>
          Export to Excel
          <FontAwesomeIcon icon={faFileDownload} className="ml-2" />
        </>
      )}

      {downloading && (
        <>
          <FontAwesomeIcon icon={faSpinner} className="mr-2 fa-spin" />
          Downloading
        </>
      )}
    </Button>
  );
};
